import React from 'react';
import { Badge } from 'react-bootstrap';
import { getListPaymentStatus } from './reconPaymentHelpers';

/** ONLINE/OFFLINE + online payment status badge (Success / Pending / …) */
const PaymentModeStatusBadges = ({ row }) => {
    const paymentStatus = getListPaymentStatus(row);
    return (
        <div className="d-flex flex-wrap gap-1 align-items-center mt-1">
            <Badge bg={row?.payment_mode === 'offline' ? 'secondary' : 'primary'}>
                {row?.payment_mode?.toUpperCase()}
            </Badge>
            {paymentStatus && (
                <span
                    title={
                        [row.reason_code, row.reason]
                            .filter(Boolean)
                            .join(' — ') || undefined
                    }
                    style={{
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 600,
                        backgroundColor: paymentStatus.color,
                        color: paymentStatus.textColor,
                    }}
                >
                    {paymentStatus.label}
                </span>
            )}
        </div>
    );
};

export default PaymentModeStatusBadges;
